
<div class="btn-group">
  <button mat-button routerLink="/blog/All/1" class="inner-category">All</button> 
</div>
<div *ngFor="let category of categories | slice: 0:4;" class="btn-group" role="group" aria-label="...">
  <button mat-button class="inner-category" routerLink="/blog/{{category.title}}/1" >{{category.title}}</button>    
</div>

<div class="btn-group">
  <button mat-button [matMenuTriggerFor]="afterMenu" class="inner-category">View More</button>
</div>
  <mat-menu #afterMenu="matMenu" xPosition="after" class="sub-category">
    <button *ngFor="let category of categories | slice: 4:-1;" routerLink="/blog/{{category.title}}/1" mat-menu-item>{{category.title}}</button>

  </mat-menu>